import { Controller } from "@hotwired/stimulus"

// Shrinks the card title font so the name never wraps past two lines.
export default class extends Controller {
  static targets = ["name"]

  static values = {
    maxFontEm: { type: Number, default: 1.32 },
    minFontEm: { type: Number, default: 0.72 },
    maxLines: { type: Number, default: 2 },
    stepEm: { type: Number, default: 0.04 }
  }

  connect() {
    this._ro = new ResizeObserver(() => this.fit())
    if (this.hasNameTarget) this._ro.observe(this.nameTarget)

    const run = () => {
      this.fit()
      document.documentElement.dataset.heroTitlesReady = "1"
    }

    if (document.fonts?.ready) {
      document.fonts.ready.then(run).catch(run)
    } else {
      run()
    }
  }

  disconnect() {
    this._ro?.disconnect()
  }

  fit() {
    if (!this.hasNameTarget) return

    const name = this.nameTarget
    let size = this.maxFontEmValue
    name.style.setProperty("--hero-title-font-size", `${size}em`)

    // Force layout before measuring.
    void name.offsetHeight

    while (size > this.minFontEmValue && this.#exceedsMaxLines(name)) {
      size = Math.round((size - this.stepEmValue) * 100) / 100
      name.style.setProperty("--hero-title-font-size", `${size}em`)
      void name.offsetHeight
    }
  }

  #exceedsMaxLines(name) {
    const sample =
      name.querySelector(".hero-card-name-primary") ||
      name.querySelector(".hero-card-name-secondary") ||
      name
    const cs = getComputedStyle(sample)
    let lineHeight = parseFloat(cs.lineHeight)
    if (!Number.isFinite(lineHeight) || cs.lineHeight === "normal") {
      lineHeight = parseFloat(cs.fontSize) * 1.05
    }
    const maxHeight = lineHeight * this.maxLinesValue + 1
    return name.scrollHeight > maxHeight
  }
}
